import React from "react";
import profileImg from "../../../assets/images/profile_verification.png";
const verifyProfileNow = () => {
  return (
    <div className="main-verification main-verify-profile-now">
    <div className="main-verify-profile-now">

  
      <div className=" title profile-title"> Profile Verification</div>

      <div className="main-profile-content h-100 d-flex flex-column align-items-center justify-content-center ">
        <div className="profile-img">
          <img src={profileImg} alt="profile-img" srcset="" />
        </div>
        <div className="verify-profile-now">verify-profile-now</div>
        <p>
          Only-few-steps-left-to-complete-Upload-remaining-documents-to-continue-using-Skycars
        </p>
      </div>
      </div>

    </div>
  );
};

export default verifyProfileNow;
